import { APIOpts } from "./APIClient";
import { constructQueryString, parseQueryParams } from "../utils/query";
import { RequestContext } from "../types/request-context";
import { Logger } from "../logger/logger";

interface AnyReqCtx {
    context?: RequestContext
    requestContext?: RequestContext,
    logger?: Logger,
    [key: string]: any
}

export enum OperationType {
    READ,
    WRITE
};

// TODO: Should we reduce this further?
export const DEFAULT_HTTP_TIMEOUT = 1000 * 15;
export const DEFAULT_WIDGET_TIMEOUT = 1000 * 15;
export const MAX_HTTP_TIMEOUT = 1000 * 60;

export const constructGetRequest = (logger: Logger, requestId: string, path: string | undefined, args: AnyReqCtx, opts: RequestInit & APIOpts): [string | undefined, RequestInit & APIOpts] => {
    const { context, requestContext, logger: _, ...rest } = args;
    const query = context && context.parameters
        ? constructQueryString(logger, parseQueryParams(context.parameters), rest)
        : constructQueryString(logger, rest);
    return [path ? path + query : undefined, {
        ...opts,
        headers: {
            ...opts.headers,
            'x-amzn-requestid': requestId
        },
        method: 'GET',
        retryable: true
    }]
}

export const constructPostFormRequest = (logger: Logger, requestId: string, url: string | undefined, args: AnyReqCtx, opts: RequestInit & APIOpts): [string | undefined, RequestInit & APIOpts] => {
    const { context, requestContext, logger: _, ...rest } = args;
    const query = context && context.parameters
        ? constructQueryString(logger, parseQueryParams(context.parameters), rest)
        : constructQueryString(logger, rest);
    return [url ? url + query : undefined, {
        ...opts,
        headers: {
            ...opts.headers,
            'Content-Type': 'application/x-www-form-urlencoded',
            'x-amzn-requestid': requestId
        },
        method: 'POST',
        retryable: false
    }];
}

export const constructPostJSONRequest = (requestId: string, url: string | undefined, args: AnyReqCtx, opts: RequestInit & APIOpts): [string | undefined, RequestInit & APIOpts] => {
    const { logger, ...rest } = args;
    return [url, {
        ...opts,
        headers: {
            ...opts.headers,
            'x-amzn-requestid': requestId
        },
        method: 'POST',
        body: JSON.stringify(rest)
    }];
}

export const constructRequest = (logger: Logger, requestId: string, url: string | undefined, args: AnyReqCtx, opts: RequestInit & APIOpts): [string | undefined, RequestInit & APIOpts] => {
    opts.retryable = opts.operationType === OperationType.READ;
    opts.timeout = opts.timeout || DEFAULT_HTTP_TIMEOUT;

    if (global.__SERVER__ || global.__DEVSERVER__) {
        return constructPostJSONRequest(requestId, url, args, opts);
    } else if (opts.operationType === OperationType.READ) {
        return constructGetRequest(logger, requestId, url, args, opts);
    } else {
        return constructPostFormRequest(logger, requestId, url, args, opts);
    }
}
